import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { isTrackCodeInternalUser } from "common/trackcodeInternal";

const AdminRoute = ({ children, user }) => {
  if (!isTrackCodeInternalUser(user)) {
    return <Redirect to="/scheduling" />;
  }

  return children;
};

AdminRoute.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.object
};

const mapStateToProps = state => ({
  user: state.auth?.user
});

export default connect(mapStateToProps)(AdminRoute);
